import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm } from 'redux-form';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import FormField from '../../shared/components/FormField';
import CardBody from '../../shared/components/CardBody';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as schemeDocumentsActions from '../actions/schemesDocumentsActions';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import SchemeDocumentsFormDocumentTypesSubForm from './SchemeDocumentsFormDocumentTypesSubForm';

class SchemeDocumentsFormCard extends React.Component {

    constructor(props) {
        super(props);

        const defaultSelectedSchemaType = ( props.schemeDocument ) ? props.schemeDocument.document_schema_type.id : -1;
        const defaultAvailableDocumentTypes = props.typeDocument.filter((documentType) => documentType.schemeType === defaultSelectedSchemaType);

        this.state = {
            selectedSchemaType: defaultSelectedSchemaType,
            availableDocumentTypes: defaultAvailableDocumentTypes,
        };
    }

    componentWillUpdate(props, state) {
        if ( state.selectedSchemaType !== this.state.selectedSchemaType || props.typeDocument !== this.props.typeDocument ) {
            const availableDocumentTypes = props.typeDocument.filter((documentType) => documentType.schemeType === state.selectedSchemaType);
            this.setState({
                availableDocumentTypes: availableDocumentTypes,
            });
        }
    }

    componentWillMount() {
        this.props.schemeDocumentsActions.getTypeDocuments();
    }

    onSubmit = (values) => {
        values.document_types.forEach((documentType) => {
            documentType.required = !documentType.optional;
        });

        values.document_type_ids = [];
        if ( this.props.schemeDocument ) {
            this.props.schemeDocumentsActions.updateSchemeDocument(values);
        } else {
            this.props.schemeDocumentsActions.addSchemeDocument(values);
            this.setState({
                availableDocumentTypes: [],
            });
        }
    };

    renderField(field) {
        return <FormField field={field}/>;
    }

    renderRadioGroup(
        {
            input,
            meta: { touched, error },
            ...rest
        },
    ) {
        return (
            <div test-id="form-categories">
                <RadioButtonGroup
                    {...input}
                    {...rest}
                    valueSelected={input.value}
                    onChange={(event, value) => {
                        input.onChange(value);
                    }}
                />
                <div className="text-error" style={{ clear: 'both', paddingBottom: '10px' }}>
                    {touched ? error : ''}
                </div>
            </div>
        );
    }

    render() {
        const {
            selectedSchemaType,
            availableDocumentTypes,
        } = this.state;

        const {
            schemeDocument,
            schemaOptions,
            typeDocument,
            handleSubmit,
            loading,
        } = this.props;

        const title = I18nUtils.tr(schemeDocument ? 'TR_EDITAR_ESQUEMA_DE_DOCUMENTO' : 'TR_CREAR_ESQUEMA_DE_DOCUMENTO');

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader title={title.toUpperCase()}/>
                    <CardBody>
                        <form onSubmit={handleSubmit(this.onSubmit)}>
                            <Row>
                                <div className="col-sm-12">
                                    <Field
                                        name="document_schema_type_id"
                                        component={this.renderRadioGroup}
                                        onChange={(event, value) => {
                                            const selectedSchemaType = value;
                                            const availableDocumentTypes = typeDocument.filter((documentType) => documentType.schemeType === selectedSchemaType);
                                            this.setState({
                                                selectedSchemaType: selectedSchemaType,
                                                availableDocumentTypes: availableDocumentTypes,
                                            });
                                        }}>
                                        {
                                            schemaOptions.map((object, i) => {
                                                return (
                                                    <RadioButton
                                                        key={i}
                                                        value={object.value}
                                                        label={object.name}
                                                        iconStyle={{ fill: 'gray', marginRight: '5px' }}
                                                        style={{ width: 'auto', float: 'left', paddingRight: '15px' }}
                                                    />
                                                );
                                            })
                                        }
                                    </Field>
                                </div>
                            </Row>
                            <Row>
                                <Field
                                    testId="form-name"
                                    label={I18nUtils.tr('TR_NOMBRE_DEL_ESQUEMA_DE_DOCUMENTO') + ':'}
                                    placeholder={I18nUtils.tr('TR_INTRODUCE_EL_NOMBRE_DEL_ESQUEMA_DE_DOCUMENTOS')}
                                    name="name"
                                    type={'text'}
                                    colWidth="col-sm-12"
                                    component={this.renderField}
                                />
                            </Row>
                            <Row>
                                <Field
                                    testId="form-description"
                                    label={I18nUtils.tr('TR_DESCRIPCION_DE_ESQUEMA_DE_DOCUMENTO') + ':'}
                                    name="notes"
                                    type={'textarea'}
                                    rows={2}
                                    colWidth="col-sm-12"
                                    component={this.renderField}
                                />
                            </Row>
                            <Row>
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label>{I18nUtils.tr('TR_INCLUIR')}</label>
                                        </div>
                                    </div>
                                    <FieldArray
                                        name="document_types"
                                        component={SchemeDocumentsFormDocumentTypesSubForm}
                                        schemaType={selectedSchemaType}
                                        documentTypes={availableDocumentTypes}
                                    />
                                </div>
                                <Field
                                    label={I18nUtils.tr(schemeDocument ? 'TR_GUARDAR' : 'TR_CREAR').toUpperCase()}
                                    name="submit"
                                    type={'submit'}
                                    colWidth="col-sm-6"
                                    component={this.renderField}
                                />
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }
}

SchemeDocumentsFormCard.propTypes = {
    schemeDocument: PropTypes.any,
};

SchemeDocumentsFormCard.defaultProps = {};

function validate(values) {
    const errors = {};

    if ( !values.document_schema_type_id || values.document_schema_type_id === -1 ) {
        errors.document_schema_type_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.document_types || values.document_types.length === 0 ) {
        errors.document_types = { _error: I18nUtils.tr('TR_CAMPO_OBLIGATORIO') };
    }

    return errors;
}

let SchemeDocumentsCreateFormCardReduxForm = reduxForm({
    validate,
    form: 'SchemeDocumentsCreateForm',
})(SchemeDocumentsFormCard);

let SchemeDocumentsEditFormCardReduxForm = reduxForm({
    validate,
    form: 'SchemeDocumentsEditForm',
})(SchemeDocumentsFormCard);

const mapStateToProps = (state, ownProps) => {

    const typeDocumentOptions = state.schemeDocuments.schemeTypeDocuments.map((documentType) => {
        return {
            value: documentType.id,
            name: documentType.name,
            schemeType: documentType.document_schema_type ? documentType.document_schema_type.id : null,
        };
    });

    const schemaOptions = [];
    state.schemaType.schemaType.forEach((schema) => {
        // ocultamos el schema de obra
        if (schema.id === 4) {
            return;
        }
        schemaOptions.push({
            value: schema.id,
            name: schema.name,
        });
    });

    let schemeDocumentValues = { document_schema_type_id: -1, document_types: [] };
    if ( ownProps.schemeDocument ) {
        schemeDocumentValues = ownProps.schemeDocument;
        schemeDocumentValues.document_schema_type_id = ownProps.schemeDocument.document_schema_type.id;
        schemeDocumentValues.document_types.forEach((documentType) => {
            documentType.optional = !documentType.required;
        });
    }

    return {
        initialValues: schemeDocumentValues,
        schemaOptions: schemaOptions,
        loading: state.schemeDocuments.schemeDocumentLoading,
        typeDocument: typeDocumentOptions,
    };
};

const mapDispatchToProps = dispatch => ( {
    schemeDocumentsActions: bindActionCreators(schemeDocumentsActions, dispatch),
} );

const StoreConnector = connect(mapStateToProps, mapDispatchToProps);

export const SchemeDocumentsCreateFormCard = StoreConnector(SchemeDocumentsCreateFormCardReduxForm);
export const SchemeDocumentsEditFormCard = StoreConnector(SchemeDocumentsEditFormCardReduxForm);



// WEBPACK FOOTER //
// ./src/app/documents/components/SchemeDocumentsFormCard.jsx